import React, { memo } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';

import FormField from './FormField';

function TextFormField({
  name,
  label,
  value,
  required = false,
  inputProps,
  onChange,
  type = 'text',
  className,
}) {
  return (
    <FormField label={label}>
      <TextField
        type={type}
        variant="outlined"
        label={label}
        onChange={(event) => onChange(event.target.value, name)}
        className={className}
        value={value}
        inputProps={inputProps}
        required={required}
      />
    </FormField>
  );
}

TextFormField.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  required: PropTypes.bool,
  inputProps: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

TextFormField.defaultProps = {
  inputProps: {},
};

export default memo(TextFormField);
